import React, { useState } from 'react';
import { ContentsItem } from '../../../modules/editor/types';

// 에디트 모듈
import TextEdit from '../Edit/TextEdit';
import ImageEdit from '../Edit/ImageEdit';
import CtaEdit from '../Edit/CtaEdit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../modules';
import { setMarkedToolbar } from '../../../modules/editor';

type Props = {
	contentItem: ContentsItem
};

function Shop({ contentItem }: Props) {

	const dispatch = useDispatch();
	
	const markedToolbar = useSelector((state: RootState) => state.editor.markedToolbar);

	const markToolbar = (contentId: number, currentIndex: number, itemType:string) => {
		dispatch(setMarkedToolbar({
			contentId: contentId,
			currentIndex: currentIndex,
			itemType: itemType
		}))
	}

	const columnPadding = () => {
		return {
			paddingLeft: contentItem.content.style[0][0].box?.paddingLeft,
			paddingRight: contentItem.content.style[0][0].box?.paddingRight,
			paddingTop: contentItem.content.style[0][0].box?.paddingTop,
			paddingBottom: contentItem.content.style[0][0].box?.paddingBottom,
		}
	}

	const contentRowPadding = (column:string[], row:string, subIndex:number, ) => {		
		const isFirst = subIndex === 0;
		if (row.includes('_hide')) {
			return {};
		}
		return isFirst ? {padding: '0 0 0 0'} : { padding: '10px 0 0 0' };
	}

	return (
		<>
			{
				contentItem.content.column.map((column: string[], index: number) => (
					<div
						key={index}
						className={`content-column column-index-${index}`}		
						style={columnPadding()}				
					>
						{
							column.map((row: string, subIndex: number) => (
								<div
									key={subIndex}
									className="content-row"
									style={contentRowPadding(column, row, subIndex)}
								>
									{/* {JSON.stringify(contentItem.content.content[index])} */}
									{/* <pre>
										{JSON.stringify(contentItem.content.style[index].button)}
									</pre> */}
									{row === 'text' && (
										<TextEdit
											contentId={contentItem.id}
											contentIndex={index}
											subIndex={subIndex}
											innerContent={contentItem.content.content[index][subIndex]}
											style={contentItem.content.style[index][subIndex].text}
											boxStyle={contentItem.content.style[index][subIndex].box}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
											contentCategory="shop"
										/>
									)}
									{row === 'cta' && (
										<CtaEdit
											contentId={contentItem.id}
											contentIndex={index}
											subIndex={subIndex}
											innerContent={contentItem.content.content[index][subIndex]}
											style={contentItem.content.style[index][subIndex].button}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
									{row === 'image' && (
										<ImageEdit
											contentId={contentItem.id}
											contentIndex={index}
											subIndex={subIndex}
											innerContent={contentItem.content.content[index][subIndex]}
											style={contentItem.content.style[index][subIndex].image}
											columnCount={contentItem.content.column.length}
											editing={contentItem.content.editing}
											markToolbar={markToolbar}
											markedToolbar={markedToolbar}
										/>
									)}
								</div>
							))
						}
					</div>
				))
			}
		</>
	)
}

export default Shop;